import { render } from "./DealTransactionTable.vue?vue&type=template&id=4867c880&scoped=true"
import script from "./DealTransactionTable.vue?vue&type=script&lang=js"
export * from "./DealTransactionTable.vue?vue&type=script&lang=js"

import "./DealTransactionTable.vue?vue&type=style&index=0&id=4867c880&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4867c880"]])

export default __exports__